import { navigate } from "gatsby";
import React, { useContext, useEffect } from "react";
import Seo from "../components/seo";
import { UserContext } from "../amplify/authenticator-provider";
import { getCognitoRoles } from "../hooks/utils";

const IndexPage = () => {
  const { authData } = useContext(UserContext);
  const accessPayload = authData.signInUserSession.accessToken.payload;
  useEffect(() => {
    if (getCognitoRoles(accessPayload)[0] === "ADMIN") {
      navigate("/admin-dashboard");
    } else {
      navigate("/engagements/activity-center");
    }
  }, []);
  return null;
};

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo title="Home" />;

export default IndexPage;
